/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/car_2'
export default icon
